var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Typography } from "antd";
import React from "react";
var PreviewView = /** @class */ (function (_super) {
    __extends(PreviewView, _super);
    function PreviewView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.render = function () {
            var _a = _this.props, value = _a.value, children = _a.children, isPreview = _a.isPreview, label = _a.label, valueStyle = _a.valueStyle, _b = _a.valueClassName, valueClassName = _b === void 0 ? "" : _b;
            return (React.createElement(React.Fragment, null,
                React.createElement("span", { style: { display: !isPreview ? "block" : "none" } }, children),
                React.createElement("div", { style: { display: isPreview ? "block" : "none" } },
                    React.createElement("div", { style: valueStyle, className: valueClassName },
                        label &&
                            React.createElement(React.Fragment, null,
                                React.createElement(Typography.Text, { className: "caption", type: "secondary" }, label),
                                React.createElement("br", null)),
                        React.createElement(Typography.Paragraph, { ellipsis: true, className: "word-break-break-word white-space-pre-wrap" }, value)),
                    React.createElement("br", null))));
        };
        return _this;
    }
    return PreviewView;
}(React.Component));
export default PreviewView;
//# sourceMappingURL=preview-view.js.map